<div class="avi-area-chart">
    <div class="avi-area-chart__viewport"></div>
</div>
